import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useSalesStore } from '@/store/sales';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/sales/sales.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sales',
  setup(__props) {

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();
const salesStore = useSalesStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => salesStore.fetchSales(params),
  {
    create: salesStore.createSale,
    update: (data) => salesStore.updateSale(data.id, data),
    remove: salesStore.deleteSale,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => salesStore.sales);


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ViewsContainer, {
        moduleName: _unref(moduleName),
        listViewComponent: Table,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/sales/sales.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        show_toolbar: true,
        show_pagination: true,
        title: {singular:'Venta', plural:'Ventas'}
      }, null, 8, ["moduleName", "data", "onCreate", "onUpdate", "onDelete"])
    ]),
    _: 1
  }))
}
}

})